var themeContract = {
  argos: {
    tracker: {
      borderColor: 'brand-3'
    },
    marker: {
      borderColor: 'brand-3',
      color: 'brand-3',
      active: {
        background: 'brand-3'
      }
    }
  },
  habitat: {
    tracker: {
      borderColor: 'brand-1'
    },
    marker: {
      borderColor: 'brand-1',
      color: 'brand-1',
      active: {
        background: 'brand-1'
      }
    }
  },
  tu: {
    tracker: {
      borderColor: 'brand-1'
    },
    marker: {
      borderColor: 'brand-1',
      color: 'brand-1',
      active: {
        background: 'brand-1'
      }
    }
  },
  nectar: {
    tracker: {
      borderColor: 'brand-1'
    },
    marker: {
      borderColor: 'brand-1',
      color: 'brand-1',
      active: {
        background: 'brand-1'
      }
    }
  },
  sainsburys: {
    tracker: {
      borderColor: 'brand-1'
    },
    marker: {
      borderColor: 'brand-1',
      color: 'brand-1',
      active: {
        background: 'brand-1'
      }
    }
  }
};
export { themeContract };